var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tooltip-button',{attrs:{"is-disabled":_vm.updateButton,"color":"warning","direction":"bottom","icon":"update","text":_vm.updateMessage},on:{"click":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }